import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AppBar, Tab, Tabs, useMediaQuery } from "@material-ui/core";
import navigationTabPanelStyles from "../styles/NavigationTabPanel.styles";

const TabPanel = ({ children, value, index, className }) => {
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			className={className}
		>
			{value === index && children}
		</div>
	);
};

const NavigationTabPanel = ({ items }) => {
	const classes = navigationTabPanelStyles();
	const tabs = items.map((item) => item.tab);
	const { hash } = useLocation();
	const mobileView = useMediaQuery((theme) => theme.breakpoints.down("xs"));

	const resolveSelectedTab = () => {
		return hash ? tabs.findIndex((t) => t === hash.substr(1)) : 0;
	};

	const selectedTab = resolveSelectedTab();

	const a11yProps = (index) => {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`
		};
	};

	return (
		<>
			<AppBar position="static" color="transparent">
				<Tabs
					value={selectedTab}
					aria-label="simple tabs"
					indicatorColor="primary"
					textColor="primary"
					variant="scrollable"
					scrollButtons={mobileView ? "on" : "auto"}
				>
					{items.map((item, i) => (
						<Tab
							label={item.label}
							{...a11yProps(i)}
							to={`#${item.tab}`}
							key={item.tab}
							component={Link}
						/>
					))}
				</Tabs>
			</AppBar>
			{items.map((item, i) => (
				<TabPanel
					className={classes.tabPanel}
					value={selectedTab}
					index={i}
					key={item.tab}
				>
					{selectedTab === i && item.component}
				</TabPanel>
			))}
		</>
	);
};

export default NavigationTabPanel;
